"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var IndexedAnimationObject_1 = require("../IndexedAnimationObject");
var EffectValueFactory_1 = require("./EffectValueFactory");
var Effect = (function (_super) {
    tslib_1.__extends(Effect, _super);
    function Effect(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        if (_this._rawData.ef === undefined) {
            _this._rawData.ef = [];
        }
        _this.effectValues = _this._rawData.ef.map(function (ev) { return EffectValueFactory_1.EffectValueFactory.constructEffectFromRawData(ev, version); });
        return _this;
    }
    Object.defineProperty(Effect.prototype, "type", {
        get: function () {
            return this._rawData.ty;
        },
        set: function (type) {
            this._rawData.ty = type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Effect.prototype, "matchName", {
        get: function () {
            return this._rawData.mn;
        },
        set: function (name) {
            this._rawData.mn = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Effect.prototype, "name", {
        get: function () {
            return this._rawData.nm;
        },
        set: function (name) {
            this._rawData.nm = name;
        },
        enumerable: true,
        configurable: true
    });
    Effect.prototype.toJSON = function () {
        return {
            type: this.type,
            index: this.index,
        };
    };
    return Effect;
}(IndexedAnimationObject_1.IndexedAnimationObject));
exports.Effect = Effect;
//# sourceMappingURL=Effect.js.map